<template>
  <div>
    <!-- Usage Right -->
    <div class="card">
      <div class="card-header">

        <table class="table">
          <thead>
            <tr>
              <th class="text-center"><i class="fa fa-flag"></i></th>
              <th>Product</th>
              <th>Codenames</th>
              <th>Merchant</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">
                <product-offer-icon v-bind:icon="usageRight.product_offer.icon" height="36px"></product-offer-icon>
              </td>

              <td>
                {{usageRight.product_offer.name}} <br/>
                <sale-option v-bind:codename="parseSaleOptionCodename(usageRight)" v-bind:duration="usageRight.transaction.sale_option_duration"/>
              </td>

              <td>
                {{usageRight.product_offer.codename}} <br/>
                <div class="small text-muted">{{usageRight.transaction.inapp_product_id}}</div>
              </td>

              <td>
                <merchant v-bind:merchant="usageRight.transaction.merchant"></merchant>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Search -->
    <div v-if="!migrated">
      <!-- Search Input -->
      <div class="form-group">
        <input type="text" class="form-control" v-model.trim="searchTerm" placeholder="Search device...">
      </div>

      <!-- Results -->
      <img v-if="isSearching" src="static/img/loading.gif" height="32"/>
      <label v-if="devices && !isSearching">Found {{filteredDevices.length}} devices</label>
      <table class="table table-condensed" v-if="filteredDevices.length > 0">
        <thead>
          <tr>
            <th>Identifier</th>
            <th>Application</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="device in filteredDevices">
            <td>
              <router-link :to="{ name: 'Device', params: {id: device.id} }" target="_blank"><span v-html="formatMatch(device.identifier)"></span></router-link>
            </td>
            <td>
              {{device.uid}}
            </td>
            <td>
              <button v-if="!isProcessing(device)" class="btn btn-primary" @click="migrate(device)"><i class="fa fa-exchange"></i> Migrate</button>
              <img v-if="isProcessing(device)" src="static/img/loading.gif" height="32"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="alert alert-success" role="alert" v-if="migrated">
      <strong>Success!</strong> Usage Right was migrated to
      <router-link :to="{ name: 'Device', params: {id: newDevice.id} }" target="_blank">{{newDevice.identifier}}</router-link>
    </div>

  </div>
</template>

<script>
import ProductOfferIcon from 'components/ProductOfferIcon'
import SaleOption from 'components/SaleOption'
import Merchant from 'components/Merchant'
import {EventBus} from 'services/eventBus'

import UsageRights from 'services/usageRights'
import SearchMixin from 'mixins/search'
import Devices from 'services/devices'
import Errors from 'services/errors'

export default {
  name: 'migrate-usage-right',
  mixins: [SearchMixin],
  props: ['usageRight', 'currentDevice'],
  data () {
    return {
      devices: [],
      migrated: false,
      processing: [],
      newDevice: {},
      searchTerm: null,
      searchPendingRequests: [],
      searchResultslimit: 10
    }
  },
  components: {
    ProductOfferIcon,
    SaleOption,
    Merchant
  },
  methods: {
    search () {
      this.clearResults()
      this.abortPendingRequests()

      if (this.ignoreTerm()) {
        return
      }
      this.adapterSearch('devices', Devices)
    },
    parseSaleOptionCodename (usageRight) {
      return UsageRights.parseSaleOptionCodename(usageRight)
    },
    clearResults () {
      this.devices = []
    },
    migrate (device) {
      this.addProcessing(device)
      Devices.migrateUsageRight(this, device.id, this.usageRight.id).then(response => {
        this.migrated = true
        this.newDevice = device
        EventBus.$emit('update-usage-rights')
      }, error => {
        Errors.notifyResponse(error)
      })
    },
    isCurrentDevice (device) {
      return device.identifier === this.currentDevice.identifier
    },
    sameApp (device) {
      return device.uid === this.currentDevice.uid
    },
    isProcessing (device) {
      return this.processing.includes(device.id)
    },
    addProcessing (device) {
      this.processing.push(device.id)
    }
  },
  computed: {
    filteredDevices () {
      return this.devices.filter((d) => {
        return !this.isCurrentDevice(d) && this.sameApp(d)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/devices/MigrateUsageRight.vue